import styled from 'styled-components';

export const Container = styled.form`
  .show-password {
    right: 14px;
    top: 77%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #6c757d;
  }
`;
